import { render, staticRenderFns } from "./BaseStatusV2.vue?vue&type=template&id=31b7420a&scoped=true&"
import script from "./BaseStatusV2.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BaseStatusV2.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BaseStatusV2.vue?vue&type=style&index=0&id=31b7420a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b7420a",
  null
  
)

export default component.exports